import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Pipe({ pure: true, name: 'muiProgramSymbol' })
export class MuiProgramSymbolPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(icon: string): string | null {
    return this.sanitizer.sanitize(SecurityContext.HTML, `&#x${icon};`);
  }
}
